import reqEnum from '../../utils/request-statuses';

export const getUsers= state => state.users.list;
export const usersStatus = state => state.users.status;
export const usersLoadingInProgress = state => state.users.status === reqEnum.loading;
export const usersError = state => state.users.error;